import { useEffect, useRef } from 'react';
import { View, StyleSheet, Animated, ViewStyle } from 'react-native';
import { theme } from '@/constants/theme';

interface SkeletonLoaderProps {
  width?: number | string;
  height?: number;
  borderRadius?: number;
  style?: ViewStyle;
}

export function SkeletonLoader({
  width = '100%',
  height = 20,
  borderRadius = 8,
  style
}: SkeletonLoaderProps) {
  const opacity = useRef(new Animated.Value(0.3)).current;

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 0.7,
          duration: 1000,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 1000,
          useNativeDriver: true,
        }),
      ])
    ).start();
  }, []);

  return (
    <Animated.View
      style={[
        styles.skeleton,
        style,
        {
          width: width as any,
          height,
          borderRadius,
          opacity,
        },
      ]}
    />
  );
}

export function SkeletonCourseCard() {
  return (
    <View style={styles.cardContainer}>
      <SkeletonLoader height={150} borderRadius={12} style={{ marginBottom: 12 }} />
      <SkeletonLoader width="80%" height={24} style={{ marginBottom: 8 }} />
      <SkeletonLoader width="100%" height={16} style={{ marginBottom: 4 }} />
      <SkeletonLoader width="90%" height={16} style={{ marginBottom: 12 }} />
      <View style={styles.row}>
        <SkeletonLoader width="30%" height={14} />
        <SkeletonLoader width="30%" height={14} />
      </View>
    </View>
  );
}

export function SkeletonLeadCard() {
  return (
    <View style={styles.leadContainer}>
      <View style={styles.row}>
        <SkeletonLoader width={40} height={40} borderRadius={20} />
        <View style={{ flex: 1 }}>
          <SkeletonLoader width="60%" height={18} style={{ marginBottom: 6 }} />
          <SkeletonLoader width="40%" height={14} />
        </View>
      </View>
      <SkeletonLoader width="100%" height={14} style={{ marginTop: 8 }} />
    </View>
  );
}

const styles = StyleSheet.create({
  skeleton: {
    backgroundColor: theme.colors.surface,
  },
  cardContainer: {
    backgroundColor: theme.colors.surface,
    padding: theme.spacing.md,
    borderRadius: 12,
    marginBottom: theme.spacing.md,
  },
  leadContainer: {
    backgroundColor: theme.colors.surface,
    padding: theme.spacing.md,
    borderRadius: 12,
    marginBottom: theme.spacing.sm,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing.sm,
  },
});
